import { render, staticRenderFns } from "./CustomerGeneral.vue?vue&type=template&id=1745946e&scoped=true&"
import script from "./CustomerGeneral.vue?vue&type=script&lang=js&"
export * from "./CustomerGeneral.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGeneral.vue?vue&type=style&index=0&id=1745946e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745946e",
  null
  
)

export default component.exports